import { render, staticRenderFns } from "./exped.vue?vue&type=template&id=0434f6dc"
import script from "./exped.vue?vue&type=script&lang=js"
export * from "./exped.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports